import { yupObject, yupBoolean } from '../../yup';

export const brokerLoanStartSchema = yupObject({
  complianceCheck: yupBoolean().required().isTrue('This field must be checked'),
});
